import { UserPlus, Check, X } from 'lucide-react';
import { useAccountLinks } from '../hooks/useAccountLinks';

export default function InvitationBanner() {
  const {
    pendingReceived,
    acceptLink,
    declineLink,
    getLinkedUserInfo
  } = useAccountLinks();

  if (pendingReceived.length === 0) return null;

  const link = pendingReceived[0]; // Show first pending request
  const linkedUser = getLinkedUserInfo(link);

  return (
    <div className="bg-accent-muted border-b border-accent/30 px-4 py-3">
      <div className="flex items-center justify-between gap-4 max-w-4xl mx-auto">
        <div className="flex items-center gap-3">
          <div className="p-1.5 rounded-lg bg-accent/20">
            <UserPlus size={16} className="text-accent" />
          </div>
          <div>
            <p className="text-sm text-text-primary">
              <span className="font-medium">{linkedUser?.displayName || linkedUser?.email}</span>
              {' '}wants to link accounts with you
            </p>
            <p className="text-[10px] text-text-tertiary">
              Share goals, policies, and 1:1 meeting notes
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => acceptLink(link.id)}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-success text-white rounded-lg text-xs font-medium border-none cursor-pointer hover:bg-success/90 transition-all"
          >
            <Check size={12} />
            Accept
          </button>
          <button
            onClick={() => declineLink(link.id)}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-surface-card text-text-secondary rounded-lg text-xs font-medium border border-border cursor-pointer hover:bg-surface-hover transition-all"
          >
            <X size={12} />
            Decline
          </button>
        </div>
      </div>

      {pendingReceived.length > 1 && (
        <p className="text-[10px] text-accent mt-1 max-w-4xl mx-auto">
          +{pendingReceived.length - 1} more request{pendingReceived.length > 2 ? 's' : ''}
        </p>
      )}
    </div>
  );
}
